<template>
  <gg-card>
    <gg-card-header :divider="showCardText">
      <v-row :class="showCardText ? '' : 'pb-3'">
        <v-col md="6">
          Install New WordPress
        </v-col>
        <v-col md="6" class="text-right">
          <gg-btn primary right @click="togglePanel">
            {{ showButtonLabel }}
          </gg-btn>
        </v-col>
      </v-row>
    </gg-card-header>
    <gg-card-text v-if="showCardText">
      <v-progress-linear v-if="loading" class="mb-1" indeterminate />

      <step-one v-show="!loadingStep" ref="stepOne" @next-step="step = 2" @prev-step="step = 1" />
      <step-two v-if="step === 2" @set-step="setStep" @set-loading="handleLoading" />
      <step-three v-if="step === 3" @collapse="showCardText = false" @set-loading="handleLoading" />
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import StepOne from './Installer/StepOne'
import StepTwo from './Installer/StepTwo'
import StepThree from './Installer/StepThree'

export default {
  name: 'WpInstall',
  components: {
    StepOne,
    StepTwo,
    StepThree,
  },
  data () {
    return {
      loading: false,
      loadingStep: false,
      showCardText: false,
    }
  },
  computed: {
    ...mapGetters({
      stepVal: 'hosting_wp_install/step',
    }),
    step: {
      get () {
        return this.stepVal
      },
      set (val) {
        if (val === 1) {
          this.$refs.stepOne.cancelSelection()
        }
        this.setStepVal(val)
      }
    },
    showButtonLabel () {
      return this.showCardText ? 'Close' : 'Install WordPress'
    }
  },
  methods: {
    ...mapActions({
      getWpSoftId: 'hosting_wp_install/getWpSoftId',
      getSoftInfo: 'hosting_wp_install/getSoftInfo',
      reportError: 'reportError'
    }),
    ...mapMutations({
      setStepVal: 'hosting_wp_install/SET_STEP',
    }),
    async loadSoftId () {
      this.loading = true
      try {
        await this.getWpSoftId(this.$route.query.user)
        await this.getSoftInfo(this.$route.query.user)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    setStep (step) {
      this.step = step
    },
    handleLoading (loading) {
      this.loadingStep = loading
    },
    togglePanel () {
      if (this.step === 2) {
        this.setStep(1)
      }
      this.showCardText = !this.showCardText
    }
  },
  mounted () {
    this.loadSoftId()
    this.step = 0
  }
}
</script>
